import React from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect } from "react-redux"; // Use connect for class components
import GridContainer from "../Grid/GridContainer";
import Card from "../Card/Card";
import CardHeader from "../Card/CardHeader";
import Language from "../../Languages/Login/content.json";
import { NewsLetterAPI } from "../../API"; // Ensure API paths are correct
import { PageStatus } from 'enums'; // Import PageStatus correctly
import { formatDate } from '../../Utils/formatDate';
import {Confirmation} from "../../Shared/Confirmation";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";


type NotificationProps = {
  language?: string;
  userId?: string;
  t: (key: string) => string;
};
class Notification extends React.Component<NotificationProps> {
  constructor(props) {
    super(props);
    this.state = {
      pageContent: this.props.language === 'hi' ? Language.profilesHindi : Language.profilesEnglish,
      status: PageStatus.Loading, // Initialize the status as Loading
      notifications: [], // Store notifications
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language !== this.props.language) {
      this.setState({
        pageContent: this.props.language === 'hi' ? Language.profilesHindi : Language.profilesEnglish,
      });
    }
  }

  componentDidMount() {
    this.appInboxDetails(); // Fetch notifications when component mounts
  }

  // Fetch notification details
  appInboxDetails = async () => {
    try {
      const response = await NewsLetterAPI.appInbox(this.props.userId);
      const notifications = response?.data?.notification ?? response?.notification ?? [];
      const list = Array.isArray(notifications) ? notifications : [];
      this.setState({
        notifications: list,
        status: PageStatus.Loaded,
      });
      try {
        await NewsLetterAPI.updateNotification({"userId": this.props.userId});
      } catch (_markReadErr) {
        // Silently ignore mark-as-read failures — notifications are still displayed
      }
    } catch (error) {
      this.setState({ notifications: [], status: PageStatus.Loaded });
    }
  };

  deleteAllNotificationsFunc = async () => {
    try {
      await NewsLetterAPI.deleteAll({"userId": this.props.userId});
      this.setState({
        notifications: [],
        status: PageStatus.Loaded,
      });
    } catch (error) {
      this.setState({ status: PageStatus.Loaded });
    }
  }

  renderNotifications() {
    const { notifications } = this.state;
    if (notifications.length === 0) {
      return <Alert variant="primary" className='text-center'>{this.props.t('notifications.noNotificationsEmptyState')}</Alert>;
    }
    return notifications.map((notification, index) => (
      <Alert variant="info" key={"notifications" + index}>
        <div >
          <div className="row">
            <div className="col-md-8">
              <h6 className="font-weight-bold">Subject</h6>
              <p>{notification.subject || ''}</p>
            </div>
            <div className="col-md-4 text-md-right">
              <h6 className="font-weight-bold">Date</h6>
              <p>{notification.sendDate ? formatDate(notification.sendDate, 'date') : ''}</p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <h6 className="font-weight-bold">Message</h6>
              <div
                dangerouslySetInnerHTML={{
                  __html: (notification.body || '').replace(/<p>/g, '<div className="p-0 m-0">').replace(/<\/p>/g, '</div>').replace(/<p>\s*<\/p>/g, ''),
                }}
              ></div>
            </div>
          </div>
        </div>
      </Alert>

    ));
  }

  render() {
    const { status } = this.state;
    const { t } = this.props;

    return (
      <>
        <GridContainer>
          <Card>
            <CardHeader color="primary">
              <div className="d-flex align-items-center justify-content-between">
                <h4>{t('notifications.inboxHeading')}</h4>
                <div>
                  <Confirmation onAction={() => this.deleteAllNotificationsFunc()} body="Are You Sure Want To Delete All Notifications?">
                    <Button
                      variant="primary"
                      size="sm"
                      // className='mx-2'
                      >
                      {t('notifications.deleteAllButton')}
                    </Button>
                  </Confirmation>
                  {/* <Button
                    onClick={() => this.props.history.push('/panelist/profile')}
                    variant="danger"
                    size="sm"
                    className='mx-2'
                  >
                    {t('common.closeButton')}
                  </Button> */}
                </div>
              </div>
            </CardHeader>
          </Card>
        </GridContainer>

        {/* Loading spinner */}
        {status === PageStatus.Loading && (
          <div className="d-flex justify-content-center w-100 p-5">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        {/* Error state */}
        {status === PageStatus.Error && (
          <Alert variant="danger">
            {t('notifications.genericError')}
          </Alert>
        )}

        {/* View notifications */}
        {status === PageStatus.Loaded && this.renderNotifications()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.adminUser.adminUser.language,
    userId: state.adminUser.adminUser.userId,
  };
};

Notification.propTypes = {
  language: PropTypes.string,
  userId: PropTypes.string,
}

const ConnectedNotification = withRouter(connect(mapStateToProps)(withTranslation()(Notification)));
export { ConnectedNotification as Notification };
